'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = require('./toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _toast2.default; /**
                                    * Created by jf on 15/10/27.
                                    */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/toast/index.js
// module id = 1800
// module chunks = 7